import { render } from "./MruResolutionTable.vue?vue&type=template&id=773c1792&scoped=true"
import script from "./MruResolutionTable.vue?vue&type=script&lang=js"
export * from "./MruResolutionTable.vue?vue&type=script&lang=js"

import "./MruResolutionTable.vue?vue&type=style&index=0&id=773c1792&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773c1792"]])

export default __exports__